import React from "react";

interface DashedArrowProps {
  className?: string;
  style?: React.CSSProperties;
}

// Orange dashed line ending in a triangle tip; the parent sets its height.
const DashedArrow: React.FC<DashedArrowProps> = ({ className = "", style }) => (
  <div className={`flex flex-col items-center ${className}`} style={style} aria-hidden="true">
    <div
      className="flex-1 w-[2px]"
      style={{ backgroundImage: "repeating-linear-gradient(180deg, #f19704 0 4px, transparent 4px 8px)" }}
    />
    <svg width="12" height="10" viewBox="0 0 12 10" className="shrink-0">
      <path d="M6 10L12 0H0Z" fill="#e17200" />
    </svg>
  </div>
);

export default DashedArrow;
